export enum StepState {
  Neutral = 'Neutral',
  Complete = 'Complete',
  Current = 'Current',
}

export enum StepPosition {
  First = 'First',
  Between = 'Between',
  Last = 'Last',
}

export interface WrapperProps {
  /** Optional class name for custom styling */
  className?: string
}

export interface StepProps {
  /** Position of the step within the progress indicator sequence */
  position: StepPosition
  /** Visual state of the step indicator */
  state: StepState
  /** Numeric label displayed inside the step bubble on tablet and larger screens */
  value: number
  /** Title text shown below the step bubble on tablet and larger screens */
  title: string
  /** Optional class name for custom styling */
  className?: string
  /** Optional link configuration to make the step indicator navigable */
  link?: {
    /** Destination URL for the link */
    href?: string
    /** HTML target attribute for the link (e.g. "_blank") */
    target?: string
    /** Accessible title attribute for the link */
    title?: string
  }
}
